window.Wishlist = (() => {
  const STORAGE_KEY = 'sc_wishlist';

  function getItems() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch {
      return [];
    }
  }

  function saveItems(items) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }

  function addItem(product) {
    const items = getItems();
    if (!items.find(i => i.id === product.id)) {
      items.push(product);
      saveItems(items);
    }
    renderDrawer();
    openDrawer();
    updateButtons();
  }

  function removeItem(id) {
    const items = getItems().filter(i => i.id !== id);
    saveItems(items);
    renderDrawer();
    updateButtons();
  }

  function isInWishlist(id) {
    return getItems().some(i => i.id === id);
  }

  function renderDrawer() {
    const container = document.getElementById('wishlist-drawer-items');
    const empty = document.getElementById('wishlist-empty');
    const items = getItems();

    if (!container) return;

    if (items.length === 0) {
      container.innerHTML = '';
      if (empty) empty.style.display = 'flex';
    } else {
      if (empty) empty.style.display = 'none';
      container.innerHTML = items.map(item => `
        <div class="wishlist-drawer-item">
          <a href="${item.url}">
            <img src="${item.image}" alt="${item.title}">
          </a>
          <div class="wishlist-drawer-item__info">
            ${item.brand ? `<span class="wishlist-drawer-item__brand">${item.brand}</span>` : ''}
            <a href="${item.url}">${item.title}</a>
            <button class="wishlist-drawer-item__remove" onclick="window.Wishlist.removeItem('${item.id}')">Remove</button>
          </div>
        </div>
      `).join('');
    }

    updateCount();
  }

  function updateCount() {
    const count = getItems().length;
    const badge = document.getElementById('wishlist-count');
    if (badge) {
      badge.textContent = count > 0 ? count : '';
      badge.style.display = count > 0 ? 'flex' : 'none';
    }
  }

  function updateButtons() {
    document.querySelectorAll('[data-wishlist-id]').forEach(btn => {
      const id = btn.getAttribute('data-wishlist-id');
      if (isInWishlist(id)) {
        btn.classList.add('wishlist-active');
        btn.setAttribute('aria-label', 'Remove from saved');
      } else {
        btn.classList.remove('wishlist-active');
        btn.setAttribute('aria-label', 'Save item');
      }
    });
  }

  function openDrawer() {
    const drawer = document.getElementById('wishlist-drawer');
    if (drawer) drawer.classList.add('wishlist-drawer--open');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    const drawer = document.getElementById('wishlist-drawer');
    if (drawer) drawer.classList.remove('wishlist-drawer--open');
    document.body.style.overflow = '';
  }

  function toggle(productData) {
    if (isInWishlist(productData.id)) {
      removeItem(productData.id);
    } else {
      addItem(productData);
    }
  }

  function share() {
    const items = getItems();
    if (items.length === 0) return;
    const ids = items.map(i => i.id).join(',');
    const url = `${window.location.origin}/pages/wishlist?ids=${ids}`;
    if (navigator.share) {
      navigator.share({ title: 'My Saved Items — Shoe Creatives', url });
    } else {
      navigator.clipboard.writeText(url).then(() => {
        const btn = document.querySelector('.wishlist-drawer__share');
        if (btn) {
          btn.textContent = 'Link copied!';
          setTimeout(() => { btn.textContent = 'Share saved items'; }, 2000);
        }
      });
    }
  }

  function init() {
    renderDrawer();
    updateButtons();

    document.body.addEventListener('click', function(e) {
      const btn = e.target.closest('[data-wishlist-id]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      toggle({
        id: btn.getAttribute('data-wishlist-id'),
        title: btn.getAttribute('data-product-title'),
        url: btn.getAttribute('data-product-url'),
        image: btn.getAttribute('data-product-image'),
        brand: btn.getAttribute('data-product-brand')
      });
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  return { addItem, removeItem, toggle, openDrawer, closeDrawer, share, isInWishlist, renderDrawer, updateButtons };
})();